import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      "hero_badge": "Professional Electronic Diagnostics",
      "hero_title": "Expert <1>Electronic</1> <2/> Diagnostics & ECU Programming",
      "hero_subtitle": "Advanced diagnostic solutions for modern vehicles. Specializing in ECU/ECM programming, electrical systems, and electronic troubleshooting.",
      "feature_1": "Latest Diagnostic Equipment",
      "feature_2": "All Makes & Models",
      "feature_3": "Expert Technicians",
      "btn_book": "Book Appointment Now",
      "btn_services": "View Services",
      "trust_text": "Trusted by hundreds of satisfied customers",
      "rating": "5.0 Average Rating",
      "reviews_title": "What Our <1>Customers Say</1>",
      "reviews_subtitle": "Don't just take our word for it - hear from our satisfied customers",
      "reviews_more": "See more reviews on",
      "google_link": "Google Reviews",
      "reviews": {
        "user1": {
          "text": "Excellent diagnostic work! They found the issue my dealership couldn't figure out. Highly recommend for any electrical problems.",
          "date": "2 weeks ago"
        },
        "user2": {
          "text": "Professional ECU programming service. My car runs better than ever. Great communication throughout the process.",
          "date": "1 month ago"
        },
        "user3": {
          "text": "The technicians at K&A Motors Tech Solutions are true experts. They quickly diagnosed and fixed my vehicle's complex electronic issues.",
          "date": "3 months ago"
        }
      },
      "services_title": "Our <1>Services</1>",
      "services_subtitle": "Comprehensive electronic diagnostic and programming solutions for all modern vehicles",
      "services_footer": "Don't see what you're looking for? We handle all types of electronic diagnostics.",
      "services_cta": "Type Us for Custom Solutions",
      "services_items": {
        "diag": { "title": "Electronic Diagnostics", "desc": "Advanced diagnostic scanning and troubleshooting for all vehicle electronic systems." },
        "ecu": { "title": "ECU/ECM Programming", "desc": "Professional engine control unit programming and calibration services." },
        "elec": { "title": "Electrical Systems", "desc": "Complete electrical system diagnosis and repair for modern vehicles." },
        "mod": { "title": "Module Repair", "desc": "Expert repair and reprogramming of vehicle control modules." },
        "sens": { "title": "Sensor Diagnostics", "desc": "Comprehensive sensor testing and calibration services." },
        "batt": { "title": "Battery Boost", "desc": "Battery Boost service provides a quick and efficient solution to restore your vehicle's battery power." },
        "oil": { "title": "Oil change", "desc": "Professional oil change service to keep your engine running smoothly." }
      },
      "about_title": "Why Choose <1>K&A Motors Tech Solutions</1>",
      "about_subtitle": "Your trusted partner for advanced automotive electronic diagnostics and programming",
      "about_h3": "Advanced Technology Meets Expert Service",
      "about_p1": "At K&A Motors Tech Solutions, we specialize in electronic diagnostics and ECU programming for all makes and models. Our state-of-the-art diagnostic equipment and experienced technicians ensure accurate diagnosis and efficient repairs.",
      "about_h4": "What Sets Us Apart",
      "about_list": [
        "Latest diagnostic tools and software",
        "Specialized in ECU/ECM programming and calibration",
        "Expert knowledge of modern vehicle electronics",
        "Fast and accurate diagnostics",
        "Competitive pricing with quality guarantee",
        "Friendly and professional service"
      ],
      "about_stats": {
        "customers": "Happy Customers",
        "experience": "Years Experience",
        "satisfaction": "Satisfaction Rate",
        "turnaround": "Quick Turnaround"
      },
      "about_cta_h3": "Ready to Get Your Vehicle Diagnosed?",
      "about_cta_p": "Our expert technicians are ready to help. Call us today or book an appointment online.",
      "btn_whatsapp": "Type us on WhatsApp",
      "btn_book_online": "Book Online",
      "footer_desc": "Your trusted partner for advanced electronic diagnostics and ECU programming services.",
      "footer_contact": "Contact Us",
      "footer_follow": "Follow us on Facebook",
      "footer_hours": "Business Hours",
      "footer_links": "Quick Links",
      "footer_rights": "All rights reserved.",
      "nav": {
        "services": "Services",
        "about": "About Us",
        "reviews": "Reviews",
        "contact": "Contact"
      },
      "hours": {
        "weekdays": "Monday - Friday: 9:00 AM - 5:00 PM",
        "saturday": "Saturday: Closed",
        "sunday": "Sunday: Closed"
      },
      "booking_title": "Book Appointment",
      "booking_subtitle": "Fill out the form and we'll contact you soon",
      "booking_personal": "Personal Information",
      "booking_vehicle": "Vehicle Information",
      "booking_details": "Appointment Details",
      "booking_name": "Full Name *",
      "booking_phone": "Phone Number *",
      "booking_email": "Email Address *",
      "booking_year": "Year *",
      "booking_make": "Make *",
      "booking_model": "Model *",
      "booking_service": "Service Needed *",
      "booking_service_placeholder": "Select a service",
      "booking_message": "Additional Details (Optional)",
      "booking_message_placeholder": "Describe the issue or any specific requirements...",
      "booking_btn_cancel": "Cancel",
      "booking_btn_next": "Next",
      "booking_btn_submitting": "Submitting...",
      "booking_error": "Failed to submit appointment. Please try again.",
      "services_list": {
        "diagnostic": "Electronic Diagnostics",
        "ecu": "ECU/ECM Programming",
        "electrical": "Electrical Systems",
        "module": "Module Repair",
        "sensor": "Sensor Diagnostics",
        "oil": "Oil Change",
        "battery": "Battery Boost"
      }

    }
  },
  es: {
    translation: {
      "hero_badge": "Diagnósticos Electrónicos Profesionales",
      "hero_title": "Expertos en <1>Electrónica</1> <2/> Diagnóstico y Programación de ECU",
      "hero_subtitle": "Soluciones avanzadas de diagnóstico para vehículos modernos. Especialistas en programación de ECU/ECM, sistemas eléctricos y fallas electrónicas.",
      "feature_1": "Equipo de Diagnóstico de Última Generación",
      "feature_2": "Todas las Marcas y Modelos",
      "feature_3": "Técnicos Expertos",
      "btn_book": "Agendar Cita Ahora",
      "btn_services": "Ver Servicios",
      "trust_text": "Con la confianza de cientos de clientes satisfechos",
      "rating": "5.0 Calificacion Promedio",
      "reviews_title": "Lo que dicen nuestros <1>clientes</1>",
      "reviews_subtitle": "No solo confíe en nuestra palabra, escuche a nuestros clientes satisfechos",
      "reviews_more": "Ver más reseñas en",
      "google_link": "Google Reviews",
      "reviews": {
        "user1": {
          "text": "¡Excelente trabajo de diagnóstico! Encontraron el problema que mi concesionario no pudo resolver. Altamente recomendado para cualquier problema eléctrico.",
          "date": "hace 2 semanas"
        },
        "user2": {
          "text": "Servicio profesional de programacion de ECU. Mi coche funciona mejor que nunca. Excelente comunicación durante todo el proceso.",
          "date": "hace 1 mes"
        },
        "user3": {
          "text": "Los técnicos de K&A Motors Tech Solutions son verdaderos expertos. Diagnosticaron y solucionaron rápidamente los problemas electrónicos de mi vehículo.",
          "date": "hace 3 meses"
        }
      },
      "services_title": "Nuestros <1>Servicios</1>",
      "services_subtitle": "Soluciones integrales de diagnóstico electrónico y programación para todos los vehículos modernos",
      "services_footer": "¿No ves lo que buscas? Manejamos todo tipo de diagnósticos electrónicos.",
      "services_cta": "Escríbenos para Soluciones Personalizadas",
      "services_items": {
        "diag": { "title": "Diagnóstico Electrónico", "desc": "Escaneo de diagnóstico avanzado y resolución de problemas para todos los sistemas electrónicos." },
        "ecu": { "title": "Programación de ECU/ECM", "desc": "Servicios profesionales de programación y calibración de unidades de control del motor." },
        "elec": { "title": "Sistemas Eléctricos", "desc": "Diagnóstico y reparación completa de sistemas eléctricos para vehículos modernos." },
        "mod": { "title": "Reparación de Módulos", "desc": "Reparación y reprogramación experta de módulos de control de vehículos." },
        "sens": { "title": "Diagnóstico de Sensores", "desc": "Servicios integrales de prueba y calibración de sensores." },
        "batt": { "title": "Auxilio de Batería", "desc": "El servicio de refuerzo de batería proporciona una solución rápida para restaurar la energía de su vehículo." },
        "oil": { "title": "Cambio de Aceite", "desc": "Servicio profesional de cambio de aceite para que su motor funcione sin problemas." }
      },
      "about_title": "Por qué elegir a <1>K&A Motors Tech Solutions</1>",
      "about_subtitle": "Su socio de confianza para diagnósticos electrónicos automotrices avanzados y programación",
      "about_h3": "Tecnología Avanzada y Servicio Experto",
      "about_p1": "En K&A Motors Tech Solutions, nos especializamos en diagnóstico electrónico y programación de ECU para todas las marcas y modelos. Nuestro equipo de vanguardia y técnicos experimentados aseguran un diagnóstico preciso y reparaciones eficientes.",
      "about_h4": "Lo que nos diferencia",
      "about_list": [
        "Últimas herramientas y software de diagnóstico",
        "Especializados en programación y calibración de ECU/ECM",
        "Conocimiento experto en electrónica de vehículos modernos",
        "Diagnósticos rápidos y precisos",
        "Precios competitivos con garantía de calidad",
        "Servicio amable y profesional"
      ],
      "about_stats": {
        "customers": "Clientes Satisfechos",
        "experience": "Años de Experiencia",
        "satisfaction": "Tasa de Satisfacción",
        "turnaround": "Entrega Rápida"
      },
      "about_cta_h3": "¿Listo para diagnosticar su vehículo?",
      "about_cta_p": "Nuestros técnicos expertos están listos para ayudar. Llámenos hoy o reserve su cita en línea.",
      "btn_whatsapp": "Escríbenos por WhatsApp",
      "btn_book_online": "Reservar en Línea",
      "footer_desc": "Su socio de confianza para servicios avanzados de diagnóstico electrónico y programación de ECU.",
      "footer_contact": "Contáctenos",
      "footer_follow": "Síguenos en Facebook",
      "footer_hours": "Horario de Atención",
      "footer_links": "Enlaces Rápidos",
      "footer_rights": "Todos los derechos reservados.",
      "nav": {
        "services": "Servicios",
        "about": "Nosotros",
        "reviews": "Reseñas",
        "contact": "Contacto"
      },
      "hours": {
        "weekdays": "Lunes - Viernes: 9:00 AM - 5:00 PM",
        "saturday": "Sábado: Cerrado",
        "sunday": "Domingo: Cerrado"
      },
      "booking_title": "Agendar Cita",
    "booking_subtitle": "Complete el formulario y nos contactaremos pronto",
    "booking_personal": "Información Personal",
    "booking_vehicle": "Información del Vehículo",
    "booking_details": "Detalles de la Cita",
    "booking_name": "Nombre Completo *",
    "booking_phone": "Número de Teléfono *",
    "booking_email": "Correo Electrónico *",
    "booking_year": "Año *",
    "booking_make": "Marca *",
    "booking_model": "Modelo *",
    "booking_service": "Servicio Requerido *",
    "booking_service_placeholder": "Seleccione un servicio",
    "booking_message": "Detalles Adicionales (Opcional)",
    "booking_message_placeholder": "Describa el problema o cualquier requerimiento específico...",
    "booking_btn_cancel": "Cancelar",
    "booking_btn_next": "Siguiente",
    "booking_btn_submitting": "Enviando...",
    "booking_error": "Error al enviar la cita. Por favor intente de nuevo.",
    "services_list": {
      "diagnostic": "Diagnóstico Electrónico",
      "ecu": "Programación de ECU/ECM",
      "electrical": "Sistemas Eléctricos",
      "module": "Reparación de Módulos",
      "sensor": "Diagnóstico de Sensores",
      "oil": "Cambio de Aceite",
      "battery": "Carga de Batería"
    }
      
    }
  }
};

i18n
  .use(LanguageDetector) // Detecta el idioma del navegador automáticamente
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: { escapeValue: false }
  });

export default i18n;